<style>.scrollWrapper {
	display: flex;
    flex-direction: row;
    justify-content: flex-end;
    height: 40px;
}
.scrollWrapper > svg {
	width: 40px;
    height: 40px;
    cursor: pointer;
    margin-left: 20px;
}
.endScroll {
	opacity: 0.3;
}</style>
<template><div class="scrollWrapper">
    <svg @click="scrollLeft" :class="{ endScroll: isMaxLeft }" fill="#C75845" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" width="40" height="40"><path d="m25.436 9.414-2.826-2.83L5.17 24l17.44 17.414 2.826-2.83L12.834 26H40v-4H12.832l12.604-12.586z"/></svg>
    <svg @click="scrollRight" :class="{ endScroll: isMaxRight }" fill="#C75845" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" width="40" height="40"><path d="M22.586 9.414 35.172 22H8v4h27.172l-12.586 12.586 2.828 2.828L42.828 24l-17.414-17.414-2.828 2.828z"/></svg>
</div></template>
<script>export default {
    data() {
        return {
        	childElement: null,
            scrollElement: null,
            leftArrow: null,
            rightArrow: null,
            scrollPosition: 0,
            isMaxLeft: true,
            isMaxRight: false
        };
    },
    mounted() {
        this.childElement = document.querySelector('.main-classes > .zoezi-workout-items');
        this.scrollElement = document.querySelector('.main-classes');
        this.scrollPosition = 0
    },
    methods: {
        updateState(maxScroll) {
            this.isMaxLeft = (this.scrollPosition <= 0);
            this.isMaxRight = (this.scrollPosition >= maxScroll);
        },
        scrollLeft() {
            const maxScroll = this.childElement.offsetWidth - this.scrollElement.offsetWidth;
            const scrollAmount = this.scrollElement.offsetWidth > 610 ? 610 : this.scrollElement.offsetWidth * 0.5;
            this.scrollPosition = this.scrollPosition - scrollAmount;
            if (this.scrollPosition < 0) this.scrollPosition = 0;
            this.scrollElement.scrollLeft =  Math.round(this.scrollPosition);
            this.updateState(maxScroll);
        },
        scrollRight() {
            const maxScroll = this.childElement.offsetWidth - this.scrollElement.offsetWidth;
            const scrollAmount = this.scrollElement.offsetWidth > 610 ? 610 : this.scrollElement.offsetWidth * 0.5;
            this.scrollPosition = this.scrollPosition + scrollAmount;
            if (this.scrollPosition > maxScroll) this.scrollPosition = maxScroll;
            this.scrollElement.scrollLeft = Math.round(this.scrollPosition);
            this.updateState(maxScroll);
        }
    }
}</script>